<template>
    <div class="TreeSearchPartsComponent">

        <p>{{lang.infotext_1}}</p>
        <b-form-input class="searchInput" id="input-search" size="sm" v-model="searchString"
            :placeholder="lang.placeholder_Search"></b-form-input>
        <br>
        <ul v-if="isData" :id="id" class="library_ul">
            <ItemSearchPartsTree :action="action" :lang="lang.TreeItem" :searchString="searchString" class="item" :model="dataSearchPartsTree"
                :edit="iscategory"></ItemSearchPartsTree>
        </ul>
        <LoaderComponent v-if="!isData"></LoaderComponent>

    </div>
</template>

<script>
import ItemSearchPartsTree from "@/components/shared/ItemSearchPartsTree"
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'


export default {
    name: 'TreeSearchPartsComponent',
    components: {
        ItemSearchPartsTree,
        LoaderComponent
    },
    props: {
        iscategory: Boolean,
        reloadTree: Boolean,
        lang: Object,
        action: Boolean
    },
    data: function () {
        return {
            open: true,
            dataItem: {},

            id: "tree_" + this._uid,
            name: '',
            searchString: ""

        };
    },
    computed: {

        ...mapGetters({
            dataSearchPartsTree: 'dataSearchPartsTree',
            reloadAfterDeleteTreeItem: 'reloadAfterDeleteTreeItem',

        }),
        isData() {


            return this.$store.getters.dataSearchPartsTree.name != ""
        }
    },
    watch: {

        reloadAfterDeleteTreeItem: function (new_isData, old_isData) {
            if (new_isData) {
                this.loadData();
                this.$store.dispatch("reloadAfterDeleteTreeItem", false)
            }
        },

        reloadTree: function (new_isData, old_isData) {
            this.loadData();
        }
    },
    mounted() {


    },
    created() {


        //this.$store.dispatch("deleteCategoryMapping");

        this.loadData();

        //this.setCategory();
    },
    updated() {

    },
    methods: {
        loadData() {
            
            this.$store.dispatch("pm_getSearchPartsCategories", this.id);
        }

    }
}
</script>


<style lang="scss">
.library_bold {
    font-weight: bold;
}

.library_ul label {
    margin-right: 0px;
}

.library_li {
    margin-top: 5px;
    margin-left: 0px;
    width: 100%;

}

.library_img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    margin-left: 5px;
}

.library_ul {
    padding-left: 18px;
    line-height: 1.5em;
    list-style-type: none;

}

.searchInput {
    font-size: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TreeSearchPartsComponent.vue